import { MethodType } from './MethodType';
import { UserWallet } from './UserWallet';

export enum BrokerEnum {
    Mercury = 'Mercury',
    Nexi = 'Nexi',
    Stripe = 'Stripe'
}

export class PaymentMethod {
    id: number;
    card_number: string;
    owner_firstName: string;
    owner_lastName: string;
    registration_date: string;
    expiryMonth: number;
    expiryYear: number;
    isValid: boolean;
    userId: number;
    paymentTypeId: number;
    walletId: string;
    paymentType: MethodType;
    broker: BrokerEnum;
    userWalletId: number;
    userWallet: UserWallet;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
